//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "TabBar",
  components: {},
  props: {
    value: {
      type: String
    },
    "tab-data": {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      editeValue: this.value
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    changeValue: function changeValue(item, index) {
      this.editeValue = item.index;
      this.$emit("change", {
        item: item,
        $index: index
      });
    }
  },
  watch: {
    value: function value(_value) {
      this.editeValue = _value;
    },
    editeValue: function editeValue(value) {
      this.$emit("input", value);
    }
  },
  filters: {}
};